import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { StyledLoading } from "../../styled/loading";

const CircularLoading = () => (
  <StyledLoading.Loading>
    <CircularProgress />
  </StyledLoading.Loading>
);

export default CircularLoading;
